import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWindowsComponent } from './simple-icons-windows.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWindowsComponent ],
    exports:      [ SimpleIconsWindowsComponent ],
    bootstrap:    []
})
export class SimpleIconsWindowsModule {}
